import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DateTimePickerContent from './components/DateTimePickerContent/DatePickerContent';

const DateTimePickerDialog = ({
  id,
  open,
  onClose,
  date,
  primaryAction,
  secondaryAction,
  DateTimePickerProps,
}) => {
  const titleId = `${id}-dialogTitle`;
  return (
    <Dialog
      scroll="paper"
      id={id}
      aria-labelledby={titleId}
      aria-modal
      open={open}
      onClose={onClose}
    >
      <DateTimePickerContent
        titleId={titleId}
        onClose={onClose}
        date={date}
        primaryAction={primaryAction}
        secondaryAction={secondaryAction}
        DateTimePickerProps={DateTimePickerProps}
      />
    </Dialog>
  );
};

const ActionType = PropTypes.shape({
  label: PropTypes.string.isRequired,
  onAction: PropTypes.func.isRequired,
});

DateTimePickerDialog.propTypes = {
  /** Dialog ID */
  id: PropTypes.string.isRequired,

  /** Is the DateTimePickerDialog component opened */
  open: PropTypes.bool,

  /** On dialog close callback */
  onClose: PropTypes.func,

  /** Default selected date */
  date: PropTypes.string,

  /** Dialog primary action config */
  primaryAction: ActionType.isRequired,

  /** Dialog secondary action config */
  secondaryAction: ActionType,

  /** Props to be sent to the DateTimePicker component */
  DateTimePickerProps: PropTypes.shape({
    /** Disable past dates selections */
    disablePast: PropTypes.bool,

    /** Disable future dates selections */
    disableFuture: PropTypes.bool,

    /** Minimum selectable date */
    minDate: PropTypes.string,

    /** Maximum selectable date */
    maxDate: PropTypes.string,

    /** Date-only selection */
    dateOnly: PropTypes.bool,
  }),
};

DateTimePickerDialog.defaultProps = {
  open: false,
  date: null,
  secondaryAction: null,
  onClose: () => {},
  DateTimePickerProps: {},
  disablePast: false,
  disableFuture: false,
  minDate: null,
  maxDate: null,
};

export default DateTimePickerDialog;
